'use client';

import SearchIcon from '@mui/icons-material/Search';
import { Button, InputAdornment, OutlinedInput, Stack } from '@mui/material';
import { recordEvent } from '@qb/frontend/analytics/ga4';
type ManufacturerSearchFormProps = {
  manufacturer: {
    id: number;
    name: string;
  };
};
export const ManufacturerSearchForm = ({
  manufacturer
}: ManufacturerSearchFormProps) => <Stack component="form" action="/search" method="get" direction={{
  xs: 'column',
  sm: 'row'
}} sx={{
  gap: 1.5,
  maxWidth: 760
}} onSubmit={event => {
  const formData = new FormData(event.currentTarget);
  recordEvent('search', {
    attributes: {
      search_phrase: String(formData.get('query') ?? ''),
      search_type: 'manufacturer',
      search_inputbox_name: 'manufacturer_page',
      manufacturer_id: manufacturer.id,
      manufacturer_name: manufacturer.name
    }
  });
}} data-sentry-element="Stack" data-sentry-component="ManufacturerSearchForm" data-sentry-source-file="ManufacturerSearchForm.tsx">
    <input type="hidden" name="manufacturerIDsFilter" value={manufacturer.id} />
    <OutlinedInput fullWidth required name="query" type="search" placeholder={`Search ${manufacturer.name} by part number or keyword`} inputProps={{
    'aria-label': `Search ${manufacturer.name} products`,
    enterKeyHint: 'search'
  }} startAdornment={<InputAdornment position="start">
          <SearchIcon color="primary" />
        </InputAdornment>} sx={{
    bgcolor: 'common.white'
  }} data-sentry-element="OutlinedInput" data-sentry-source-file="ManufacturerSearchForm.tsx" />
    <Button type="submit" variant="contained" size="large" data-sentry-element="Button" data-sentry-source-file="ManufacturerSearchForm.tsx">
      Search products
    </Button>
  </Stack>;